module.exports = __webpack_public_path__ + "img/Cambodia.641d8826.svg";